/* Ilersis · Datos de facturación en la cesta (Coopernicode, 14-10-2026)
 * Particular → NIF/DNI/NIE obligatorio. Empresa → razón social + CIF/NIF obligatorios.
 * Se guardan como atributos del carrito («Tipo de cliente», «NIF/CIF», «Razón social»)
 * y aparecen en el pedido, en «Detalles adicionales». Sin datos válidos no se pasa al pago.
 */
(function () {
  if (customElements.get('ilx-facturacion')) return;

  var DNI_LETTERS = 'TRWAGMYFPDXBNJZSQVHLCKE';

  function clean(v) {
    return String(v || '').toUpperCase().replace(/[\s.\-\/]/g, '');
  }

  function validDniLike(v) {
    // DNI (12345678Z), NIE (X1234567L) y NIF especiales K/L/M
    var m = v.match(/^([XYZKLM]?)(\d{7,8})([A-Z])$/);
    if (!m) return false;
    var prefix = m[1], digits = m[2], letter = m[3];
    if (prefix === 'X' || prefix === 'Y' || prefix === 'Z') {
      if (digits.length !== 7) return false;
      digits = { X: '0', Y: '1', Z: '2' }[prefix] + digits;
    } else if (prefix) {
      if (digits.length !== 7) return false;
    } else if (digits.length !== 8) {
      return false;
    }
    return DNI_LETTERS.charAt(parseInt(digits, 10) % 23) === letter;
  }

  function validCif(v) {
    var m = v.match(/^([ABCDEFGHJNPQRSUVW])(\d{7})([0-9A-J])$/);
    if (!m) return false;
    var type = m[1], digits = m[2], control = m[3];
    var sum = 0;
    for (var i = 0; i < 7; i++) {
      var n = parseInt(digits.charAt(i), 10);
      if (i % 2 === 0) {
        n = n * 2;
        sum += Math.floor(n / 10) + (n % 10);
      } else {
        sum += n;
      }
    }
    var d = (10 - (sum % 10)) % 10;
    var l = 'JABCDEFGHI'.charAt(d);
    if ('PQRSNW'.indexOf(type) > -1) return control === l;
    if ('ABEH'.indexOf(type) > -1) return control === String(d);
    return control === String(d) || control === l;
  }

  function validForeign(v) {
    // Identificador fiscal de otro país (p. ej. IVA intracomunitario FR12345678901)
    return /^[A-Z]{2}[A-Z0-9]{4,18}$/.test(v) && v.slice(0, 2) !== 'ES';
  }

  function validate(type, raw) {
    var v = clean(raw);
    if (v.indexOf('ES') === 0 && v.length > 9) v = v.slice(2);
    if (!v) return { ok: false, reason: 'empty', value: v };
    var ok = validDniLike(v) || validForeign(v) || (type === 'empresa' && validCif(v));
    return { ok: ok, reason: ok ? '' : 'format', value: v };
  }

  class IlxFacturacion extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.radios = this.querySelectorAll('input[name$="[tipo]"]');
      this.nif = this.querySelector('[data-ilx-nif]');
      this.razon = this.querySelector('[data-ilx-razon]');
      this.razonWrap = this.querySelector('[data-ilx-razon-wrap]');
      this.nifLabel = this.querySelector('[data-ilx-nif-label]');
      this.nifErr = this.querySelector('[data-ilx-nif-err]');
      this.razonErr = this.querySelector('[data-ilx-razon-err]');
      this.root = this.closest('cart-drawer') || this.closest('cart-form') || document;
      this.saveTimer = null;
      this.lastSaved = '';

      var self = this;
      this.radios.forEach(function (r) {
        r.addEventListener('change', function () { self.touched = false; self.sync(); self.save(); });
      });
      [this.nif, this.razon].forEach(function (el) {
        el.addEventListener('input', function () { self.touched = false; self.sync(true); self.queueSave(); });
        el.addEventListener('blur', function () { self.touched = true; self.sync(); self.save(); });
      });

      // Bloquea cualquier vía de pago de esta cesta mientras falten datos
      this._guard = function (evt) {
        var t = evt.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], a.btn[href$="/cart"], .additional-checkout-buttons');
        if (!t || !self.isConnected) return;
        if (!self.contains(evt.target) && !self.root.contains(t)) return;
        if (!self.isValid()) {
          evt.preventDefault();
          evt.stopPropagation();
          self.touched = true;
          self.sync();
          self.focusFirstError();
          return;
        }
        if (self.isSaved()) return;
        // Datos válidos pero aún sin guardar: guardar primero y luego seguir al pago
        evt.preventDefault();
        evt.stopPropagation();
        self.save().then(function () {
          if (t.tagName === 'A') {
            window.location.href = t.href;
          } else if (t.form) {
            var h = document.createElement('input');
            h.type = 'hidden'; h.name = 'checkout'; h.value = '1';
            t.form.appendChild(h);
            t.form.submit();
          }
        });
      };
      document.addEventListener('click', this._guard, true);
      var form = this.closest('form');
      if (form) {
        form.addEventListener('submit', function (evt) {
          var sub = evt.submitter;
          if (sub && sub.name === 'update') return;
          if (!self.isValid()) {
            evt.preventDefault();
            self.touched = true;
            self.sync();
            self.focusFirstError();
          }
        }, true);
      }
      // Los valores iniciales salen de los atributos ya guardados en el carrito
      if (this.dataset.saved === 'true') this.lastSaved = this.payload();
      this.sync();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._guard, true);
    }

    type() {
      var t = 'particular';
      this.radios.forEach(function (r) { if (r.checked) t = r.value; });
      return t;
    }

    state() {
      var type = this.type();
      var n = validate(type, this.nif.value);
      var razon = (this.razon.value || '').trim();
      return {
        type: type,
        nif: n,
        razonOk: type !== 'empresa' || razon.length >= 2,
        razon: razon
      };
    }

    isValid() {
      var s = this.state();
      return s.nif.ok && s.razonOk;
    }

    sync(quiet) {
      var s = this.state();
      var empresa = s.type === 'empresa';
      this.razonWrap.hidden = !empresa;
      this.razon.required = empresa;
      this.nifLabel.textContent = empresa ? this.dataset.labelEmpresa : this.dataset.labelParticular;
      this.nif.placeholder = empresa ? 'B12345678' : '12345678Z';

      var showErr = this.touched && !quiet;
      var nifMsg = '';
      if (showErr && !s.nif.ok) nifMsg = s.nif.reason === 'empty' ? this.dataset.errVacio : this.dataset.errFormato;
      this.nifErr.textContent = nifMsg;
      this.nif.setAttribute('aria-invalid', nifMsg ? 'true' : 'false');

      var razonMsg = showErr && !s.razonOk ? this.dataset.errRazon : '';
      this.razonErr.textContent = razonMsg;
      this.razon.setAttribute('aria-invalid', razonMsg ? 'true' : 'false');

      var valid = s.nif.ok && s.razonOk;
      this.classList.toggle('is-valid', valid);
      if (this.root && this.root.classList) this.root.classList.toggle('ilx-fact-pendiente', !valid);
    }

    focusFirstError() {
      var s = this.state();
      var el = !s.nif.ok ? this.nif : this.razon;
      el.focus({ preventScroll: false });
      el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    queueSave() {
      var self = this;
      clearTimeout(this.saveTimer);
      this.saveTimer = setTimeout(function () { self.save(); }, 600);
    }

    payload() {
      var s = this.state();
      return JSON.stringify({
        attributes: {
          'Tipo de cliente': s.type === 'empresa' ? 'Empresa' : 'Particular',
          'NIF/CIF': s.nif.ok ? s.nif.value : '',
          'Razón social': s.type === 'empresa' ? s.razon : ''
        }
      });
    }

    isSaved() {
      return this.payload() === this.lastSaved;
    }

    save() {
      var body = this.payload();
      if (body === this.lastSaved) return Promise.resolve();
      var self = this;
      var url = (window.theme && theme.routes && theme.routes.cartUpdate) || '/cart/update';
      if (!/\.js$/.test(url)) url += '.js';
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body,
        keepalive: true
      }).then(function (r) {
        if (r.ok) self.lastSaved = body;
      }).catch(function () {});
    }
  }

  customElements.define('ilx-facturacion', IlxFacturacion);
})();
